// extracted by mini-css-extract-plugin
export var arrow_wrapper = "timelineContainer-module--arrow_wrapper--AV8u1";
export var era_slider = "timelineContainer-module--era_slider--kKRGD";
export var slide_0 = "timelineContainer-module--slide_0--Iu5SZ";
export var slide_1 = "timelineContainer-module--slide_1--WcD+z";
export var slide_10 = "timelineContainer-module--slide_10--Risfp";
export var slide_11 = "timelineContainer-module--slide_11--vX93L";
export var slide_12 = "timelineContainer-module--slide_12--SXurH";
export var slide_13 = "timelineContainer-module--slide_13--3waM3";
export var slide_14 = "timelineContainer-module--slide_14--8wrnr";
export var slide_2 = "timelineContainer-module--slide_2--Rtaa0";
export var slide_3 = "timelineContainer-module--slide_3--uCm+s";
export var slide_4 = "timelineContainer-module--slide_4--xQg-F";
export var slide_5 = "timelineContainer-module--slide_5--DoxfU";
export var slide_6 = "timelineContainer-module--slide_6--oZNDp";
export var slide_7 = "timelineContainer-module--slide_7--K-2jx";
export var slide_8 = "timelineContainer-module--slide_8--RJtVg";
export var slide_9 = "timelineContainer-module--slide_9--W6QYj";
export var timeline_container = "timelineContainer-module--timeline_container--jFizk";